import { render, staticRenderFns } from "./special-translate.vue?vue&type=template&id=02977ef3&scoped=true&"
import script from "./special-translate.vue?vue&type=script&lang=ts&"
export * from "./special-translate.vue?vue&type=script&lang=ts&"
import style0 from "./special-translate.vue?vue&type=style&index=0&id=02977ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02977ef3",
  null
  
)

export default component.exports